import { render, staticRenderFns } from "./hours.vue?vue&type=template&id=b68c0298&scoped=true"
import script from "./hours.vue?vue&type=script&lang=js"
export * from "./hours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68c0298",
  null
  
)

export default component.exports